import { render } from "./RemoteControlSettingInfoTab.vue?vue&type=template&id=22f50370&scoped=true&ts=true"
import script from "./RemoteControlSettingInfoTab.vue?vue&type=script&lang=ts"
export * from "./RemoteControlSettingInfoTab.vue?vue&type=script&lang=ts"

import "./RemoteControlSettingInfoTab.vue?vue&type=style&index=0&id=22f50370&lang=scss&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/hems-frontend-vue_au_v1.33.0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22f50370"]])

export default __exports__